import React, { useState, useEffect } from "react";
import { PageLayout } from "../components/page-layout";
import EventCard from "../components/events/event";
import { isUserSiteAdmin } from "../components/shared/utilities";
import { getEventById } from "../services/event-service";
import { useParams } from "react-router-dom";
import { useAuth0 } from "@auth0/auth0-react";
import { useNavigate } from "react-router-dom";
import ExceptionMessage from "../components/shared/exception-message";

export const EventPage = () => {
 
    let { id } = useParams();
    const [event, setEvent] = useState(null);
    const { getAccessTokenSilently, user } = useAuth0();
    const [eventLoadingError, setEventLoadingError] = useState(null);
    const isUserAdmin = isUserSiteAdmin(user);

    useEffect(() => {
        if (!id) return;
        
        let isMounted = true; // Track if component is still mounted
        
        const retrieveEvent = async () => {
            try {
                setEventLoadingError(null); // Clear previous errors
                const token = await getAccessTokenSilently();
                
                if (!isMounted) return; // Abort if component unmounted
                
                const result = await getEventById(token, id);
                
                if (!isMounted) return; // Abort if component unmounted
                
                if (result.error) {
                    console.error("Error retrieving event:", result.error);
                    setEventLoadingError(result.error);
                    setEvent(null);
                } else {
                    setEvent(result.data);
                    setEventLoadingError(null);
                }
            } catch (err) {
                if (isMounted) {
                    console.error("Unexpected error loading event:", err);
                    setEventLoadingError({ message: "Failed to load event" });
                    setEvent(null);
                }
            }
        };
        
        retrieveEvent();
        
        
        return () => {
            isMounted = false;
        };
    }, [id]); 

    return (
        <PageLayout>
            {eventLoadingError && <div style={{padding: "12px"}}><ExceptionMessage message={"Oh no! There was an issue loading this event."} /></div>}
            {event && !eventLoadingError && <EventCard event={event} />}
        </PageLayout>
    )
};